import { ADD_ITEM, SIDEBAR_ITEM, SIDEBAR_LAYOUT } from "@mosanic/constants/items";

//Item types
export const isNewDropItem = (type) => [SIDEBAR_ITEM, ADD_ITEM, SIDEBAR_LAYOUT].includes(type)
export const isNewDropLayout = (item) => [SIDEBAR_LAYOUT, 'section'].includes(item?.layoutType)
export const isMoveDropItem = (type) => !isNewDropItem(type) && !isNewDropLayout(type);
